import PropTypes from 'prop-types';
import React from 'react';

import StylingToCSSTextQuestion from 'styling/hocs/StylingToCSS/StylingToCSSTextQuestion';
import propTypeStyleTextQuestion from 'styling/config/editorBlock/PropTypes/styleTextQuestion';

import styles from './QuestionNumber.scss';

const QuestionNumber = ({ number, styleTextQuestion }) =>
  number ? (
    <span
      data-e2e="question-number"
      data-testid="SurveysSpa-QuestionNumber-Number"
      className={styles.questionNumber}
      style={styleTextQuestion}
    >
      {number}
    </span>
  ) : null;

QuestionNumber.propTypes = {
  number: PropTypes.number,
  styleTextQuestion: propTypeStyleTextQuestion,
};

export default StylingToCSSTextQuestion(QuestionNumber);
